import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "header-title-section" }
const _hoisted_4 = { class: "employee-navigator" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "emp-selector-wrapper" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "emp-counter" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "header-controls" }
const _hoisted_11 = { class: "year-month-selector" }
const _hoisted_12 = { class: "current-period" }
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "view-tabs" }
const _hoisted_17 = { class: "count-badge" }
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_20 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_21 = {
  key: 0,
  class: "calendar-grid-container"
}
const _hoisted_22 = { class: "caregiver-info-bar" }
const _hoisted_23 = { class: "caregiver-badge" }
const _hoisted_24 = { class: "avatar-text" }
const _hoisted_25 = { class: "badge-info" }
const _hoisted_26 = { class: "badge-name" }
const _hoisted_27 = { class: "badge-job" }
const _hoisted_28 = { class: "quick-stats" }
const _hoisted_29 = { class: "stat" }
const _hoisted_30 = { class: "stat-value" }
const _hoisted_31 = { class: "stat" }
const _hoisted_32 = { class: "stat-value" }
const _hoisted_33 = { class: "stat" }
const _hoisted_34 = { class: "stat-value" }
const _hoisted_35 = { class: "calendar-wrapper" }
const _hoisted_36 = { class: "calendar-header" }
const _hoisted_37 = { class: "calendar-body" }
const _hoisted_38 = { class: "day-header" }
const _hoisted_39 = {
  key: 0,
  class: "today-chip"
}
const _hoisted_40 = {
  key: 0,
  class: "day-schedules"
}
const _hoisted_41 = ["onMouseenter"]
const _hoisted_42 = { class: "chip-text" }
const _hoisted_43 = {
  key: 0,
  class: "more-schedules"
}
const _hoisted_44 = { class: "patient-list-card" }
const _hoisted_45 = { class: "patient-chips" }
const _hoisted_46 = ["onMouseenter"]
const _hoisted_47 = { class: "chip-name" }
const _hoisted_48 = { class: "chip-count" }
const _hoisted_49 = { class: "chip-hours" }
const _hoisted_50 = {
  key: 1,
  class: "calendar-grid-container"
}
const _hoisted_51 = { class: "patient-info-bar" }
const _hoisted_52 = { class: "patient-selector-area" }
const _hoisted_53 = { class: "select-wrapper" }
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "patient-stats-row" }
const _hoisted_56 = { class: "stat-box" }
const _hoisted_57 = { class: "stat-value" }
const _hoisted_58 = { class: "stat-box" }
const _hoisted_59 = { class: "stat-value" }
const _hoisted_60 = { class: "stat-box" }
const _hoisted_61 = { class: "stat-value" }
const _hoisted_62 = { class: "calendar-wrapper" }
const _hoisted_63 = { class: "calendar-header" }
const _hoisted_64 = { class: "calendar-body" }
const _hoisted_65 = { class: "day-header" }
const _hoisted_66 = {
  key: 0,
  class: "today-chip"
}
const _hoisted_67 = {
  key: 0,
  class: "day-schedules"
}
const _hoisted_68 = { class: "chip-info" }
const _hoisted_69 = { class: "chip-time" }
const _hoisted_70 = { class: "chip-service" }
const _hoisted_71 = {
  key: 0,
  class: "more-schedules"
}

import { ref, computed, watch, nextTick } from 'vue';
import { homeScheduleApi } from '@/services/api';
import { mapSchedulePlanRows, normalizeScheduleDate } from '@/utils/scheduleDate';
import { downloadPdfBlob, getApiErrorMessage } from '@/utils/downloadPdf';
import LtcsMissingRequestCta from '@/components/member/request/LtcsMissingRequestCta.vue';

interface ScheduleData {
  clsp_idx: number;
  clsp_date: string;
  clsp_start_time: string;
  clsp_end_time: string;
  clsp_recipient_name: string;
  clsp_recipient_cert_number: string;
  clsp_caregiver_name: string;
  clsp_caregiver_birth: string;
  clsp_service_type: string;
  clsp_fee_name: string;
}

interface CalendarDay {
  day: number;
  date: string;
  isCurrentMonth: boolean;
  isToday: boolean;
  dayOfWeek: number;
}

interface Props {
  modelValue: boolean;
  caregiver: any;
  caregivers?: any[];
  memberCode: number | string;
  bizGubun?: string;
  year?: number;
  month?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduleCalendarModal',
  props: {
    modelValue: { type: Boolean },
    caregiver: {},
    caregivers: {},
    memberCode: {},
    bizGubun: {},
    year: {},
    month: {}
  },
  emits: ["update:modelValue", "change-caregiver"],
  setup(__props: any, { emit: __emit }) {

const SCHEDULE_LTCS_REQUEST_TYPES = ['caion_ltcs_schedule_plan'] as const;

const props = __props;
const emit = __emit;

const currentEmployeeIndex = ref(0);
const activeView = ref<'caregiver' | 'patient'>('caregiver');
const hoveredPatient = ref<string | null>(null);
const selectedPatient = ref('');

const caregiverList = computed(() => {
  if (props.caregivers && props.caregivers.length > 0) {
    return props.caregivers;
  }
  return props.caregiver ? [props.caregiver] : [];
});

const currentEmployee = computed(() => {
  return caregiverList.value[currentEmployeeIndex.value] || props.caregiver;
});

const canNavigatePrev = computed(() => currentEmployeeIndex.value > 0);
const canNavigateNext = computed(() => currentEmployeeIndex.value < caregiverList.value.length - 1);

const navigateEmployee = (delta: number) => {
  const newIndex = currentEmployeeIndex.value + delta;
  if (newIndex >= 0 && newIndex < caregiverList.value.length) {
    currentEmployeeIndex.value = newIndex;
    emit('change-caregiver', currentEmployee.value);
    fetchScheduleData();
  }
};

const onEmployeeChange = () => {
  emit('change-caregiver', currentEmployee.value);
  fetchScheduleData();
};

const isLoading = ref(false);
const isPdfLoading = ref(false);
const scheduleData = ref<ScheduleData[]>([]);
/** 일정 조회에 실제 사용된 bizGubun (필터 재시도 후 PDF와 동일 조건 유지) */
const scheduleFetchBizGubun = ref<string | undefined>(undefined);

const today = new Date();
const selectedYear = ref(props.year || today.getFullYear());
const selectedMonth = ref(props.month || (today.getMonth() + 1));
const requestYearMonth = computed(
  () => `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`
);

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const yearOptions = computed(() => {
  const currentYear = new Date().getFullYear();
  return [currentYear - 2, currentYear - 1, currentYear, currentYear + 1];
});

const weekDays = ['일', '월', '화', '수', '목', '금', '토'];

const calendarDays = computed<CalendarDay[]>(() => {
  const year = selectedYear.value;
  const month = selectedMonth.value;

  const firstDay = new Date(year, month - 1, 1);
  const startDay = new Date(firstDay);
  startDay.setDate(startDay.getDate() - firstDay.getDay());

  const days: CalendarDay[] = [];
  const current = new Date(startDay);
  const todayStr = formatDateStr(today);

  for (let i = 0; i < 42; i++) {
    const isCurrentMonth = current.getMonth() === month - 1;
    const dateStr = formatDateStr(current);

    days.push({
      day: current.getDate(),
      date: dateStr,
      isCurrentMonth,
      isToday: dateStr === todayStr,
      dayOfWeek: current.getDay()
    });

    current.setDate(current.getDate() + 1);
  }

  return days;
});

const uniquePatients = computed(() => {
  const patients = new Set(scheduleData.value.map(s => s.clsp_recipient_name));
  return Array.from(patients).filter(Boolean).sort();
});

const monthlyStats = computed(() => {
  const uniqueDays = new Set(scheduleData.value.map(s => s.clsp_date));
  const uniquePatientsSet = new Set(scheduleData.value.map(s => s.clsp_recipient_name));

  let totalMinutes = 0;
  scheduleData.value.forEach(s => {
    totalMinutes += calculateMinutes(s.clsp_start_time, s.clsp_end_time);
  });

  return {
    totalDays: uniqueDays.size,
    totalHours: formatHours(totalMinutes),
    patientCount: uniquePatientsSet.size
  };
});

const getPatientStats = computed(() => {
  if (!selectedPatient.value) return { totalDays: 0, totalHours: '0h', visitCount: 0 };
  
  const patientSchedules = scheduleData.value.filter(s => s.clsp_recipient_name === selectedPatient.value);
  const uniqueDays = new Set(patientSchedules.map(s => s.clsp_date));
  
  let totalMinutes = 0;
  patientSchedules.forEach(s => {
    totalMinutes += calculateMinutes(s.clsp_start_time, s.clsp_end_time);
  });
  
  return {
    totalDays: uniqueDays.size,
    totalHours: formatHours(totalMinutes),
    visitCount: patientSchedules.length
  };
});

const patientList = computed(() => {
  const ptData: Record<string, { count: number; minutes: number }> = {};

  scheduleData.value.forEach(s => {
    if (!ptData[s.clsp_recipient_name]) {
      ptData[s.clsp_recipient_name] = { count: 0, minutes: 0 };
    }
    ptData[s.clsp_recipient_name].count++;
    ptData[s.clsp_recipient_name].minutes += calculateMinutes(s.clsp_start_time, s.clsp_end_time);
  });

  return Object.entries(ptData)
    .map(([name, data]) => ({
      name,
      count: data.count,
      hours: formatHours(data.minutes)
    }))
    .sort((a, b) => b.count - a.count);
});

const patientColors: Record<string, string> = {};
const colorPalette = [
  '#ef4444', '#3b82f6', '#22c55e', '#a855f7', '#f97316',
  '#14b8a6', '#ec4899', '#4f46e5', '#eab308', '#64748b'
];

const getPatientColor = (name: string): string => {
  if (!patientColors[name]) {
    const idx = Object.keys(patientColors).length % colorPalette.length;
    patientColors[name] = colorPalette[idx];
  }
  return patientColors[name];
};

const formatDateStr = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const formatTime = (time: string | undefined): string => {
  if (!time) return '';
  const str = time.toString().replace(/[^0-9]/g, '');
  if (str.length >= 4) {
    return `${str.slice(0, 2)}:${str.slice(2, 4)}`;
  }
  return time;
};

const calculateMinutes = (startTime: string, endTime: string): number => {
  const start = formatTime(startTime).split(':');
  const end = formatTime(endTime).split(':');
  if (start.length < 2 || end.length < 2) return 0;

  const startMinutes = parseInt(start[0]) * 60 + parseInt(start[1]);
  const endMinutes = parseInt(end[0]) * 60 + parseInt(end[1]);
  return Math.max(0, endMinutes - startMinutes);
};

const formatHours = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (mins > 0) return `${hours}h ${mins}m`;
  return `${hours}h`;
};

const getDaySchedules = (dateStr: string): ScheduleData[] => {
  return scheduleData.value.filter((s) => normalizeScheduleDate(s.clsp_date) === dateStr);
};

const getPatientDaySchedules = (dateStr: string): ScheduleData[] => {
  if (!selectedPatient.value) return [];
  return scheduleData.value.filter(
    (s) =>
      normalizeScheduleDate(s.clsp_date) === dateStr &&
      s.clsp_recipient_name === selectedPatient.value
  );
};

const changeMonth = (delta: number) => {
  let newMonth = selectedMonth.value + delta;
  let newYear = selectedYear.value;

  if (newMonth > 12) {
    newMonth = 1;
    newYear++;
  } else if (newMonth < 1) {
    newMonth = 12;
    newYear--;
  }

  selectedMonth.value = newMonth;
  selectedYear.value = newYear;
  fetchScheduleData();
};

const fetchScheduleData = async () => {
  const emp = currentEmployee.value;
  if (!props.memberCode || !emp?.emp_name) return;

  const empBirth = emp.emp_birth ? String(emp.emp_birth).split('T')[0] : '';
  if (!empBirth) {
    scheduleData.value = [];
    return;
  }

  try {
    isLoading.value = true;
    const yearMonth = `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`;

    let effectiveBizGubun: string | undefined = props.bizGubun || undefined;
    let res = await homeScheduleApi.getCaregiverSchedule(
      props.memberCode,
      emp.emp_name,
      yearMonth,
      effectiveBizGubun,
      empBirth
    );

    if (
      res.data.success &&
      (!res.data.data || res.data.data.length === 0) &&
      props.bizGubun
    ) {
      effectiveBizGubun = undefined;
      res = await homeScheduleApi.getCaregiverSchedule(
        props.memberCode,
        emp.emp_name,
        yearMonth,
        undefined,
        empBirth
      );
    }

    scheduleFetchBizGubun.value = effectiveBizGubun;

    if (res.data.success) {
      scheduleData.value = mapSchedulePlanRows(res.data.data || []);
      if (uniquePatients.value.length > 0 && !uniquePatients.value.includes(selectedPatient.value)) {
        selectedPatient.value = uniquePatients.value[0];
      }
    } else {
      scheduleData.value = [];
    }
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '일정 조회에 실패했습니다.';
    const status = error.response?.status || '';
    console.error('일정 데이터 조회 오류:', error);
    alert(`일정 조회 실패: ${message}${status ? ` (${status})` : ''}`);
    scheduleData.value = [];
  } finally {
    isLoading.value = false;
  }
};

const printSchedulePdf = async () => {
  const emp = currentEmployee.value;
  if (!props.memberCode || !emp?.emp_name) return;

  const empBirth = emp.emp_birth ? String(emp.emp_birth).split('T')[0] : '';
  if (!empBirth) {
    alert('생년월일이 있어야 일정표 PDF를 출력할 수 있습니다.');
    return;
  }

  try {
    isPdfLoading.value = true;
    const yearMonth = `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`;

    const bizForPdf = scheduleFetchBizGubun.value;
    let res = await homeScheduleApi.downloadCaregiverPdf(
      props.memberCode,
      emp.emp_name,
      yearMonth,
      bizForPdf,
      empBirth
    );

    downloadPdfBlob(res.data, `일정표_${emp.emp_name}_${yearMonth}.pdf`);
  } catch (error: unknown) {
    const message = await getApiErrorMessage(error, '일정표 PDF 출력에 실패했습니다.');
    console.error('PDF 출력 오류:', error);
    alert(`일정표 PDF 출력 실패: ${message}`);
  } finally {
    isPdfLoading.value = false;
  }
};

const close = () => {
  dialogVisible.value = false;
};

watch(dialogVisible, async (visible) => {
  if (visible) {
    selectedYear.value = props.year || today.getFullYear();
    selectedMonth.value = props.month || (today.getMonth() + 1);
    activeView.value = 'caregiver';
    selectedPatient.value = '';
    scheduleFetchBizGubun.value = undefined;

    if (props.caregivers && props.caregivers.length > 0 && props.caregiver) {
      const idx = props.caregivers.findIndex(e =>
        e.emp_name === props.caregiver.emp_name && e.emp_birth === props.caregiver.emp_birth
      );
      currentEmployeeIndex.value = idx >= 0 ? idx : 0;
    } else {
      currentEmployeeIndex.value = 0;
    }

    await nextTick();
    if (currentEmployee.value?.emp_name) {
      await fetchScheduleData();
    }
  }
});

watch([selectedYear, selectedMonth], async ([newYear, newMonth], [oldYear, oldMonth]) => {
  if (dialogVisible.value && (newYear !== oldYear || newMonth !== oldMonth)) {
    await fetchScheduleData();
  }
});

watch(uniquePatients, (patients) => {
  if (patients.length > 0 && !patients.includes(selectedPatient.value)) {
    selectedPatient.value = patients[0];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialogVisible).value = $event)),
    "max-width": "1200px",
    scrollable: "",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "schedule-calendar-modal" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                size: "24",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("mdi-calendar-clock", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "emp-nav-btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateEmployee(-1))),
                    disabled: !canNavigatePrev.value,
                    title: "이전 직원"
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("mdi-chevron-left", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentEmployeeIndex).value = $event)),
                      class: "emp-select",
                      onChange: onEmployeeChange
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(caregiverList.value, (emp, idx) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: `${emp.emp_name}-${emp.emp_birth}`,
                          value: idx
                        }, _toDisplayString(emp.emp_name) + " (" + _toDisplayString(emp.emp_job || '요양보호사') + ") ", 9, _hoisted_7))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, currentEmployeeIndex.value]
                    ]),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(currentEmployeeIndex.value + 1) + " / " + _toDisplayString(caregiverList.value.length), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "emp-nav-btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateEmployee(1))),
                    disabled: !canNavigateNext.value,
                    title: "다음 직원"
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_9)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "nav-btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (changeMonth(-1)))
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedYear).value = $event)),
                    class: "year-select"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, (y) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: y,
                        value: y
                      }, _toDisplayString(y) + "년", 9, _hoisted_13))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, selectedYear.value]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedMonth).value = $event)),
                    class: "month-select"
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (m) => {
                      return _createElementVNode("option", {
                        key: m,
                        value: m
                      }, _toDisplayString(m) + "월", 9, _hoisted_14)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, selectedMonth.value]
                  ])
                ]),
                _createElementVNode("button", {
                  class: "nav-btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (changeMonth(1)))
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("button", {
                class: "pdf-btn",
                onClick: printSchedulePdf,
                disabled: isPdfLoading.value || scheduleData.value.length === 0,
                title: "일정표 PDF 출력"
              }, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(isPdfLoading.value ? 'mdi-loading mdi-spin' : 'mdi-file-pdf-box'), 1)
                  ]),
                  _: 1
                }),
                _cache[18] || (_cache[18] = _createElementVNode("span", null, "PDF", -1))
              ], 8, _hoisted_15),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: close
              }, [
                _createVNode(_component_v_icon, {
                  size: "20",
                  color: "white"
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              class: _normalizeClass(["view-tab", { active: activeView.value === 'caregiver' }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (activeView.value = 'caregiver'))
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                  _createTextVNode("mdi-account-hard-hat", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(currentEmployee.value?.emp_name) + " 근무일정", 1)
            ], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["view-tab", { active: activeView.value === 'patient' }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (activeView.value = 'patient'))
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createTextVNode("mdi-account-heart", -1)
                ]))]),
                _: 1
              }),
              _cache[22] || (_cache[22] = _createElementVNode("span", null, "담당 수급자", -1)),
              _createElementVNode("span", _hoisted_17, _toDisplayString(uniquePatients.value.length), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_18, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "#0d47a1",
                    size: "40"
                  }),
                  _cache[23] || (_cache[23] = _createElementVNode("span", null, "일정을 불러오는 중...", -1))
                ]))
              : (scheduleData.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createVNode(_component_v_icon, {
                      size: "56",
                      color: "#cbd5e1"
                    }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode("mdi-calendar-blank", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[25] || (_cache[25] = _createElementVNode("h3", null, "일정 데이터가 없습니다", -1)),
                    _createElementVNode("p", null, _toDisplayString(selectedYear.value) + "년 " + _toDisplayString(selectedMonth.value) + "월에 " + _toDisplayString(currentEmployee.value?.emp_name) + "님의 일정이 없습니다.", 1),
                    _createVNode(LtcsMissingRequestCta, {
                      "member-code": __props.memberCode,
                      "biz-gubun": __props.bizGubun,
                      "year-month": requestYearMonth.value,
                      types: SCHEDULE_LTCS_REQUEST_TYPES,
                      onUpdated: fetchScheduleData
                    }, null, 8, ["member-code", "biz-gubun", "year-month"])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (activeView.value === 'caregiver')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_v_avatar, {
                                size: "36",
                                color: "#0d47a1"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(currentEmployee.value?.emp_name?.charAt(0)), 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("span", _hoisted_26, _toDisplayString(currentEmployee.value?.emp_name), 1),
                                _createElementVNode("span", _hoisted_27, _toDisplayString(currentEmployee.value?.emp_job || '요양보호사'), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("span", _hoisted_30, _toDisplayString(monthlyStats.value.totalDays), 1),
                                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "stat-label" }, "근무일", -1))
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("span", _hoisted_32, _toDisplayString(monthlyStats.value.totalHours), 1),
                                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "stat-label" }, "총 시간", -1))
                              ]),
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("span", _hoisted_34, _toDisplayString(monthlyStats.value.patientCount), 1),
                                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "stat-label" }, "담당 수급자", -1))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDays, (day) => {
                                return _createElementVNode("div", {
                                  class: _normalizeClass(["weekday", { sunday: day === '일', saturday: day === '토' }]),
                                  key: day
                                }, _toDisplayString(day), 3)
                              }), 64))
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarDays.value, (day, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: idx,
                                  class: _normalizeClass(["calendar-day", { 
                    'other-month': !day.isCurrentMonth,
                    'today': day.isToday,
                    'has-schedule': getDaySchedules(day.date).length > 0
                  }])
                                }, [
                                  _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["day-number", { sunday: day.dayOfWeek === 0, saturday: day.dayOfWeek === 6 }])
                                    }, _toDisplayString(day.day), 3),
                                    (day.isToday)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, "TODAY"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (day.isCurrentMonth)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDaySchedules(day.date).slice(0, 4), (schedule, sIdx) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: sIdx,
                                            class: _normalizeClass(["schedule-chip-inline", { 'highlighted': hoveredPatient.value === schedule.clsp_recipient_name }]),
                                            style: _normalizeStyle({ borderLeftColor: getPatientColor(schedule.clsp_recipient_name) }),
                                            onMouseenter: ($event: any) => (hoveredPatient.value = schedule.clsp_recipient_name),
                                            onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (hoveredPatient.value = null))
                                          }, [
                                            _createElementVNode("span", _hoisted_42, _toDisplayString(schedule.clsp_recipient_name) + " " + _toDisplayString(formatTime(schedule.clsp_start_time)) + "-" + _toDisplayString(formatTime(schedule.clsp_end_time)), 1)
                                          ], 46, _hoisted_41))
                                        }), 128)),
                                        (getDaySchedules(day.date).length > 4)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, " +" + _toDisplayString(getDaySchedules(day.date).length - 4), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("h4", null, [
                              _createVNode(_component_v_icon, {
                                size: "18",
                                color: "#0d47a1"
                              }, {
                                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                  _createTextVNode("mdi-account-heart", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[30] || (_cache[30] = _createTextVNode(" 담당 수급자 목록 ", -1))
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(patientList.value, (pt) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: pt.name,
                                  class: _normalizeClass(["patient-chip", { 'highlighted': hoveredPatient.value === pt.name }]),
                                  style: _normalizeStyle({ borderLeftColor: getPatientColor(pt.name) }),
                                  onMouseenter: ($event: any) => (hoveredPatient.value = pt.name),
                                  onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (hoveredPatient.value = null))
                                }, [
                                  _createElementVNode("div", {
                                    class: "chip-color",
                                    style: _normalizeStyle({ backgroundColor: getPatientColor(pt.name) })
                                  }, null, 4),
                                  _createElementVNode("span", _hoisted_47, _toDisplayString(pt.name), 1),
                                  _createElementVNode("span", _hoisted_48, _toDisplayString(pt.count) + "회", 1),
                                  _createElementVNode("span", _hoisted_49, _toDisplayString(pt.hours), 1)
                                ], 46, _hoisted_46))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (activeView.value === 'patient')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _cache[32] || (_cache[32] = _createElementVNode("label", { class: "select-label" }, "수급자 선택", -1)),
                              _createElementVNode("div", _hoisted_53, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selectedPatient).value = $event)),
                                  class: "person-select"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniquePatients.value, (patient) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: patient,
                                      value: patient
                                    }, _toDisplayString(patient), 9, _hoisted_54))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, selectedPatient.value]
                                ]),
                                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "select-arrow" }, "▼", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("span", _hoisted_57, _toDisplayString(getPatientStats.value.totalDays), 1),
                                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "stat-label" }, "서비스일", -1))
                              ]),
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("span", _hoisted_59, _toDisplayString(getPatientStats.value.totalHours), 1),
                                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "stat-label" }, "총시간", -1))
                              ]),
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("span", _hoisted_61, _toDisplayString(getPatientStats.value.visitCount), 1),
                                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "stat-label" }, "방문", -1))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDays, (day) => {
                                return _createElementVNode("div", {
                                  class: _normalizeClass(["weekday", { sunday: day === '일', saturday: day === '토' }]),
                                  key: day
                                }, _toDisplayString(day), 3)
                              }), 64))
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarDays.value, (day, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: idx,
                                  class: _normalizeClass(["calendar-day", { 
                    'other-month': !day.isCurrentMonth,
                    'today': day.isToday,
                    'has-schedule': getPatientDaySchedules(day.date).length > 0
                  }])
                                }, [
                                  _createElementVNode("div", _hoisted_65, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["day-number", { sunday: day.dayOfWeek === 0, saturday: day.dayOfWeek === 6 }])
                                    }, _toDisplayString(day.day), 3),
                                    (day.isToday)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_66, "TODAY"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (day.isCurrentMonth)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPatientDaySchedules(day.date).slice(0, 3), (schedule, sIdx) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: sIdx,
                                            class: "schedule-chip caregiver"
                                          }, [
                                            _cache[36] || (_cache[36] = _createElementVNode("div", { class: "chip-dot" }, null, -1)),
                                            _createElementVNode("div", _hoisted_68, [
                                              _createElementVNode("span", _hoisted_69, _toDisplayString(formatTime(schedule.clsp_start_time)) + "-" + _toDisplayString(formatTime(schedule.clsp_end_time)), 1),
                                              _createElementVNode("span", _hoisted_70, _toDisplayString(schedule.clsp_fee_name || schedule.clsp_service_type), 1)
                                            ])
                                          ]))
                                        }), 128)),
                                        (getPatientDaySchedules(day.date).length > 3)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, " +" + _toDisplayString(getPatientDaySchedules(day.date).length - 3) + "건 ", 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})